<template>
  <div
    v-if="sections && !topics"
    style="overflow-y: scroll; overflow-x: hidden; background-color: white"
  >
    <div v-for="section in sections" :key="section.description">
      <vetalfa-section-title
        :prop="section.description"
        :collapse="section.collapse"
        :isCollapsed="collapseAll"
      >
        <vetalfa-simple-table v-if="section.table" :table="section.table">
        </vetalfa-simple-table>
        <vetalfa-section-paragraph
          v-for="(paragraph, index) in section.paragraphs"
          :key="index + paragraph"
          :prop="paragraph"
        ></vetalfa-section-paragraph>
        <vetalfa-section-item-title
          v-for="(obj1, index) in section.objects"
          :key="index + obj1.description"
          :prop="obj1.description"
        >
          <vetalfa-simple-table v-if="obj1.table" :table="obj1.table">
          </vetalfa-simple-table>
          <vetalfa-section-item
            v-for="(obj2, index) in obj1.objects"
            :key="index + obj2.description"
            :prop="obj2.description"
            :references="obj2.references"
            :index="index"
          >
            <vetalfa-simple-table v-if="obj2.table" :table="obj2.table">
            </vetalfa-simple-table>
            <vetalfa-section-sub-item
              v-for="(obj3, index) in obj2.objects"
              :key="index + obj3.description"
              :prop="obj3.description"
              :references="obj3.references"
              :index="index"
            >
              <vetalfa-simple-table v-if="obj3.table" :table="obj3.table">
              </vetalfa-simple-table>
            </vetalfa-section-sub-item>
          </vetalfa-section-item>
        </vetalfa-section-item-title>
      </vetalfa-section-title>
    </div>
    <vetalfa-section-title
      v-if="references && references.length"
      :prop="_getLabel('REFERENCES')"
    >
      <div v-for="reference in references" :key="reference.name">
        <vetalfa-reference-card :reference="reference"></vetalfa-reference-card>
      </div>
    </vetalfa-section-title>
    <div style="height: 30px; background-color: white"></div>
  </div>
  <div
    v-else-if="sections && adminMode"
    id="vetalfa-general-tab"
    style="overflow-y: scroll; overflow-x: hidden; background-color: white"
  >
    <v-expansion-panels
      v-model="expansionPanelModel"
      accordion
      class="mt-2"
      multiple
    >
      <v-expansion-panel
        v-for="macroTopic in topicsSections"
        :key="`macro-topic-${macroTopic.text}`"
      >
        <v-expansion-panel-header class="ma-0 pa-0 pl-2 pr-3">
          <span class="vetalfa-card-title">{{ macroTopic.text }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ma-0 pa-0 pb-5 mb-5">
          <vetalfa-sections :sections="macroTopic.sections"></vetalfa-sections>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="references && references.length"
        :prop="_getLabel('REFERENCES')"
      >
        <v-expansion-panel-header dense class="ma-0 pa-0 pl-2 pr-3">
          <span class="vetalfa-card-title">{{ _getLabel("REFERENCES") }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ma-0 pa-0 pb-5 mb-5">
          <vetalfa-section-title
            v-if="!!internalReferences && !!internalReferences.length"
            :prop="_getLabel('INTERNAL_REFERENCES')"
          >
            <div v-for="reference in internalReferences" :key="reference.name">
              <vetalfa-reference-card
                :reference="reference"
              ></vetalfa-reference-card>
            </div>
          </vetalfa-section-title>
          <vetalfa-section-title
            v-if="!!externalReferences && !!externalReferences.length"
            :prop="_getLabel('EXTERNAL_REFERENCES')"
          >
            <div v-for="reference in externalReferences" :key="reference.name">
              <vetalfa-reference-card
                :reference="reference"
              ></vetalfa-reference-card>
            </div>
          </vetalfa-section-title>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <vetalfa-references-dialog></vetalfa-references-dialog>
    <div style="height: 1px; background-color: white"></div>
  </div>
  <div
    v-else
    id="vetalfa-general-tab"
    style="overflow-y: scroll; overflow-x: hidden; background-color: white"
  >
    <v-timeline
      id="vetalfa-algorithms-timeline"
      class="ma-0 pa-0"
      align-top
      dense
    >
      <v-timeline-item
        v-for="(macroTopic, index) in topicsSections"
        :key="`macro-topic-${macroTopic.text}`"
        fill-dot
        color="white"
        small
        v-bind:class="index > 0 ? 'ma-0 pa-0 mt-5 pt-2' : 'ma-0 pa-0'"
      >
        <template v-slot:icon>
          <div
            class="vetalfa-general-tab-timeline-avatar primary vetalfa-pointer"
            @click="openContent(macroTopic, index)"
          >
            <p class="ma-0 pa-0 white--text text-center">{{ index + 1 }}</p>
          </div>
        </template>
        <v-row class="vetalfa-card-text ma-0 pa-0 pl-2 mt-1">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              @click="openContent(macroTopic, index)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
            >
              <b class="ma-0 pa-0 primary--text text-left">
                {{ macroTopic.text }}
              </b>
            </v-row>
          </v-col>
          <v-col
            v-for="(section, sectionIndex) in macroTopic.sections.filter(
              (s) => {
                return s.style == 1;
              }
            )"
            :key="section.text + sectionIndex"
            cols="12"
            class="ma-0 pa-0 mt-3"
          >
            <v-row
              @click="openContent(macroTopic, index, section)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
            >
              <span class="ma-0 pa-0 text-decoration-underline text-left">
                {{ section.text }}
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-timeline-item>
      <v-timeline-item
        fill-dot
        outlined
        color="white"
        class="ma-0 pa-0 mt-5 pt-2"
        small
      >
        <template v-slot:icon>
          <div
            class="vetalfa-general-tab-timeline-avatar primary vetalfa-pointer"
            @click="setClickedReferences(references)"
          >
            <p class="ma-0 pa-0 white--text text-center">
              {{ topicsSections.length + 1 }}
            </p>
          </div>
        </template>
        <v-row class="vetalfa-card-text ma-0 pa-0 pl-2 mt-1">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              @click="setClickedReferences(references)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
            >
              <b class="ma-0 pa-0 primary--text">
                {{ _getLabel("REFERENCES") }}
              </b>
            </v-row>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
    <div style="height: 50px; background-color: white"></div>
    <vetalfa-dialog
      v-on:dialogClose="contentModel = false"
      :title="itemName"
      :toggleModel="contentModel"
      :height="$vuetify.breakpoint.xsOnly ? null : totalHeight"
    >
      <template v-slot:header>
        <vetalfa-drugs-header
          :isDrugsMode="true"
          :name="!!content ? content.macroTopic.text : ''"
          :description="topicName"
        ></vetalfa-drugs-header>
      </template>
      <template v-if="content">
        <vetalfa-sections
          :sections="content.macroTopic.sections"
        ></vetalfa-sections>
        <v-row
          align="center"
          v-if="!!previousAndNextContents"
          class="ma-0 pa-0 mt-5 pt-5"
        >
          <v-col
            @click="
              openContent(
                topicsSections[content.index - 1],
                content.index - 1,
                null,
                true
              )
            "
            class="ma-0 pa-0 vetalfa-pointer"
            cols="1"
          >
            <v-icon v-if="!!previousAndNextContents.previous" color="primary">
              {{ mdiChevronLeft }}
            </v-icon>
          </v-col>
          <v-col
            @click="
              openContent(
                topicsSections[content.index - 1],
                content.index - 1,
                null,
                true
              )
            "
            class="ma-0 pa-0 primary--text text-decoration-underline text-left vetalfa-pointer"
            cols="4"
          >
            <span clas="ma-0 pa-0" v-if="!!previousAndNextContents.previous">
              {{ topicsSections[content.index - 1].text }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            @click="
              openContent(
                topicsSections[content.index + 1],
                content.index + 1,
                null,
                true
              )
            "
            class="ma-0 pa-0 primary--text text-right text-decoration-underline pr-1 vetalfa-pointer"
            cols="4"
          >
            <span v-if="!!previousAndNextContents.next">
              {{ topicsSections[content.index + 1].text }}
            </span>
          </v-col>
          <v-col
            @click="
              openContent(
                topicsSections[content.index + 1],
                content.index + 1,
                null,
                true
              )
            "
            class="ma-0 pa-0 text-center vetalfa-pointer"
            cols="1"
          >
            <v-icon
              v-if="!!previousAndNextContents.next"
              color="primary"
              class="ma-0 pa-0"
            >
              {{ mdiChevronRight }}
            </v-icon>
          </v-col>
        </v-row>
        <div style="height: 50px; background-color: white"></div>
      </template>
    </vetalfa-dialog>
    <vetalfa-references-dialog></vetalfa-references-dialog>
  </div>
</template>

<style>
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.v-application--is-ltr
  .v-list--dense
  .v-list-group--sub-group
  .v-list-group__header {
  padding-left: 8px !important;
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  > .v-list-group__items
  > .v-list-item {
  padding-left: 60px !important;
}
.vetalfa-general-tab-timeline-avatar {
  height: 14px;
  width: 14px;
  border-radius: 7px;
  font-size: 10px;
  line-height: 14px;
  padding-top: 1px;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import Vimeo from "@/components/Vimeo.vue";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
export default {
  name: "GeneralTab",
  components: {
    "vetalfa-vimeo": Vimeo,
    "vetalfa-references-dialog": ReferencesDialog,
  },
  watch: {
    sections() {
      if (process.env.VUE_APP_ENV == "production") {
        this.expansionPanelModel = [];
      }
    },
    contentModel(val) {
      if (!val) {
        this.content = null;
      }
    },
  },
  computed: {
    ...mapGetters("topics", ["itemContent", "clickedReferences"]),
    topicsSections() {
      let macroTopics = [];
      if (this.topics) {
        let macroTopicIndex = -1;
        for (let section of this.sections) {
          if (section.style == 0) {
            macroTopicIndex++;
            macroTopics.push({ ...section, sections: [] });
          } else {
            macroTopics[macroTopicIndex].sections.push(section);
          }
        }
      }
      return macroTopics;
    },

    content: {
      get() {
        return this.itemContent;
      },
      set(val) {
        this.setItemContent(val);
      },
    },
    internalReferences() {
      return this.references.filter((reference) => {
        return !!reference.type && reference.type == 1;
      });
    },
    externalReferences() {
      return this.references.filter((reference) => {
        return !reference.type || reference.type == 0;
      });
    },
    previousAndNextContents() {
      let obj = { previous: null, next: null };
      if (!!this.content) {
        obj.previous = this.topicsSections[this.content.index - 1];
        obj.next = this.topicsSections[this.content.index + 1];
      }
      return obj;
    },
  },
  methods: {
    ...mapMutations("general", ["setGoToSection"]),
    ...mapMutations("topics", ["setClickedReferences", "setItemContent"]),
    isDoseReference(item) {
      return (
        !!item.references &&
        item.references.length == 1 &&
        !!item.references[0].dose
      );
    },
    getItemIndex(sections, sectionIndex) {
      try {
        return [3, 4].includes(sections[sectionIndex - 1].style) &&
          !this.isDoseReference(sections[sectionIndex - 1])
          ? 1
          : 0;
      } catch (error) {
        return 0;
      }
    },
    openContent(macroTopic, index, section = null, scrollBefore = false) {
      if (scrollBefore && !!this.content.macroTopic) {
        document
          .getElementById(
            this._createIdentifier(this.content.macroTopic.sections[0].text)
          )
          .scrollIntoView();
      }
      this.content = {
        macroTopic,
        section,
        index,
      };
      this.contentModel = true;
      if (!scrollBefore) {
        setTimeout(
          function () {
            document
              .getElementById(
                this._createIdentifier(
                  !!this.content.section
                    ? this.content.section.text
                    : this.content.macroTopic.sections[0].text
                )
              )
              .scrollIntoView({ behavior: "smooth" });
          }.bind(this),
          500
        );
      }
    },
  },
  props: {
    sections: {
      type: Array,
    },
    references: {
      type: Array,
      default: null,
    },
    collapseAll: {
      type: Boolean,
      default: false,
    },
    topics: {
      type: Boolean,
      default: false,
    },
    itemName: {
      type: String,
      default: "",
    },
    topicName: {
      type: String,
      default: "",
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
      expansionPanelModel: [],
      contentModel: false,
      totalHeight: 0,
    };
  },
  mounted() {
    if (this.content) {
      this.openContent(
        this.content.macroTopic,
        this.content.index,
        this.content.section
      );
    }
    this.$nextTick(() => {
      setTimeout(
        function () {
          const root = document.querySelector(":root");
          this.totalHeight = document.getElementById(
            "vetalfa-general-tab"
          ).offsetHeight;
          root.style.setProperty(
            "--pseudo-timeline-height",
            `${this.totalHeight - 70}px`
          );
          root.style.setProperty("--pseudo-timeline-top", "10px");
        }.bind(this),
        100
      );
    });
  },
};
</script>